import React, { Fragment, lazy, memo, useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';

import { Fetching, globalActions, loginActions } from 'primary-components';

import { dataSharingHooks } from 'hooks/modules';
import { routing } from 'routing';

import NavigationMobile from 'primary/NavigationMobile';

import ErrorBoundaryLocal from '../ErrorBoundary';

const Datalake = lazy(() => import('components/modules/Datalake'))
const Statuses = lazy(() => import('components/modules/Statuses'))

const MobileRouting = () => {
  const dispatch = useDispatch(),
        defaultPage = useSelector(state => state.myAccountState.settingsState.defaultPage),
        getPathByAccess = useCallback(component => {
          if(dispatch(loginActions.hasAccessTo(component))) {
            return component;
          }
        }, [dispatch]),
        userAccess = useMemo(() => defaultPage ?
          {
            statuses: getPathByAccess(routing.statuses.name),
            lake: getPathByAccess(routing.dataLake.name)
          }
          : 
          {}, [defaultPage, getPathByAccess]),
        fallbackPage = useMemo(() => Object.values(userAccess).find(path => path),[userAccess])
  
  dataSharingHooks.useProviders()

  useEffect(() => {
    if(defaultPage && !fallbackPage){
      dispatch(globalActions.onChange(false, "isMobile"))
    }
  }, [defaultPage, dispatch, fallbackPage])

  return (
    <Routes>
      <Route
          element={defaultPage ? (
            <Fragment>
              <NavigationMobile/>
              <Outlet/>
            </Fragment>
          ) : <Fetching isFetching/>}
          ErrorBoundary={ErrorBoundaryLocal}
          path="/"
      >
        <Route 
            element={<Datalake/>}
            ErrorBoundary={ErrorBoundaryLocal}
            path={`${getPathByAccess(routing.dataLake.name)}/*`}
        />
        <Route
            element={<Statuses/>}
            ErrorBoundary={ErrorBoundaryLocal}
            path={`${getPathByAccess(routing.statuses.name)}/*`}
        />
        {fallbackPage && (
          <Route 
              element={
                <Navigate to={`/${fallbackPage}`}/>
              }
              ErrorBoundary={ErrorBoundaryLocal}
              path="*"
          />
        )}
      </Route>
    </Routes>
  )
}

export default memo(MobileRouting);
